import { defaultInputProps } from '../../../../../FormContainer/defaultFormStates';
import { getTrafficSources } from '../../../../../common/commonRequests';
import { checkAffiliateManager } from '../../../../../PermissionsWrappers/permissionChecks';

const isExternal = [
  { value: '0', display: 'Internal' },
  { value: '1', display: 'External' }
];

export const editAffiliate = () => ({
  affiliate_name: {
    ...defaultInputProps,
    name: 'affiliate_name',
    label: 'Affiliate Name'
  },
  is_external: {
    ...defaultInputProps,
    name: 'is_external',
    type: 'select',
    label: 'External',
    options: () => isExternal,
    hidden: checkAffiliateManager()
  },
  show_spanish: {
    ...defaultInputProps,
    name: 'show_spanish',
    type: 'checkbox',
    label: 'Show All Spanish Presells',
    defaultVal: '-1',
    width: 6,
    centered: true
  },
  logpixel: {
    ...defaultInputProps,
    name: 'logpixel',
    type: 'checkbox',
    label: 'Log Pixels',
    defaultVal: '1',
    width: 6,
    centered: true
  },
  giraffeAffiliate: {
    ...defaultInputProps,
    name: 'giraffeAffiliate',
    type: 'checkbox',
    label: 'This is a Giraffe Affiliate',
    defaultVal: '0',
    width: 6,
    centered: true
  },
  reconcileGoogleAffiliate: {
    ...defaultInputProps,
    name: 'reconcileGoogleAffiliate',
    type: 'checkbox',
    label: 'Reconcile Google',
    defaultVal: '0',
    width: 6,
    centered: true
  },
  reconcileFacebookAffiliate: {
    ...defaultInputProps,
    name: 'reconcileFacebookAffiliate',
    type: 'checkbox',
    label: 'Reconcile Facebook',
    defaultVal: '0',
    width: 6,
    centered: true
  },
  ottoNativeAffiliate: {
    ...defaultInputProps,
    name: 'ottoNativeAffiliate',
    type: 'checkbox',
    label: 'OTTO Native Internal Affiliate',
    defaultVal: '0',
    width: 6,
    centered: true
  },
  outbound_calls: {
    ...defaultInputProps,
    name: 'outbound_calls',
    type: 'checkbox',
    label: 'Outbound Calls',
    defaultVal: 0,
    width: 6,
    centered: true
  },
  traffic_source: {
    ...defaultInputProps,
    name: 'traffic_source',
    type: 'select',
    label: 'Traffic Source',
    defaultVal: '-1',
    options: () => getTrafficSources()
  }
});
